const stepsRubros = [
    {
        id: 1,
        img: "/assets/cerv/elearning/icon_seguridad.png",
        title: "Seguridad",
        desc: "",
        number: "01",
        link: "#"
    },
    {
        id: 2,
        img: "/assets/cerv/elearning/icon_operaciones.png",
        title: "Operaciones",
        desc: "",
        number: "02",
        link: "#"
    },
    {
        id: 3,
        img: "/assets/cerv/elearning/icon_operaciones.png",
        title: "Mantenimiento",
        desc: "",
        number: "03",
        link: "#"
    },
]

const steps = [
    {
        id: 1,
        img: "/assets/cerv/elearning/area_Altoriesgo.png",
        title: "Seguridad",
        desc: "Videos",
        number: "01",
        link: "#"
    },
    {
        id: 2,
        img: "/assets/cerv/elearning/area_equipos.png",
        title: "Operaciones",
        desc: "Talleres 360º",
        number: "02",
        link: "#"
    },
    {
        id: 3,
        img: "/assets/cerv/elearning/area_manejar.png",
        title: "Mantenimiento",
        desc: "Interactivos",
        number: "03",
        link: "#"
    },
    {
        id: 4,
        img: "/assets/cerv/elearning/area_pala.png",
        title: "Evaluaciones",
        desc: "Evaluaciones progresivas",
        number: "04",
        link: "#"
    }
]

const presentation = {
    title: "Aplicaciones HSE",
    description: [
        "Software a la medida, hacemos que el cliente entienda y nos compre. Soluciones a la medida como automatización de procesos, reportabilidad, aplicaciones móviles, etc."
    ],
    photo: "https://play-lh.googleusercontent.com/81W7HgjOiVFwNk45OsYkioCPJek71QC6iW-ViDjWw8Bx_X7KUWTOAjTu2HhZoq81aj0=w2560-h1440-rw",
    type: "photo",
    textPosition: "left",
    overlayBackground: "rgb(14 3 39 / 50%)"
}

const cursso = {
    title: "Trabajo previo en Soluciones a Medida",
    description: [
        "Rubro: Minería, Transporte, Vehículos y Maquinaria Pesada, Industria, Seguridad Industrial, Operaciones, Mantenimiento Preventivo",
        "Soluciones en simuladores a medida y personalizados para empresas."
    ],
    photo: "https://www.youtube.com/watch?v=LFD83qrdmCI",
    type: "video",
    textPosition: "right",
    overlayBackground: "linear-gradient(rgb(16 9 62) 3.92%, rgba(9, 18, 29, 0) 36.79%, rgb(24 11 55) 83.98%), url('/assets/images/backgroup/bg_pagetitle.png') center center no-repeat"
}

const trabajosEspaciosConfinados = {
    title: "Trabajos en espacios confinados",
    description: [
        "El simulador para seguridad en trabajos de alto riesgo e inspección se recrea escenarios críticos para capacitar en prácticas seguras, identificación de riesgos y cumplimiento de protocolos, fortaleciendo la prevención y la cultura de seguridad laboral"
    ],
    photo: "https://www.youtube.com/watch?v=hhwJj6jZXSE",
    type: "video",
    textPosition: "left",
    overlayBackground: "url('/assets/images/backgroup/bg_pagetitle.png') no-repeat center center / cover"
}

const simuladorRockBraker = {
    title: "Simulador de equipo operación Rock Braker",
    description: [
        "El simulador de operación son herramienta innovadora que recrea entornos reales para capacitar en el manejo seguro y eficiente de equipos de perforación minera, mejorando habilidades técnicas y reduciendo riesgos operativos."
    ],
    photo: "https://www.youtube.com/watch?v=SVWvc13GLPc",
    type: "video",
    textPosition: "left",
    overlayBackground: "url('/assets/images/backgroup/bg_pagetitle.png') no-repeat center center / cover"
}

const inspeccionCAEX = {
    title: "Inspeccion CAEX",
    description: [
        "El simulador de inspección de equipos permite practicar la evaluación detallada de maquinaria minera en un entorno virtual, fortaleciendo competencias en detección de fallas y mantenimiento preventivo."
    ],
    photo: "https://www.youtube.com/watch?v=hwOHBHOm9Iw",
    type: "video",
    textPosition: "left",
    overlayBackground: "url('/assets/images/backgroup/bg_pagetitle.png') no-repeat center center / cover"
}

export { stepsRubros, steps, presentation, cursso, trabajosEspaciosConfinados, simuladorRockBraker, inspeccionCAEX };



